import React, { useRef, useEffect, useState } from 'react';
import styled from "styled-components"

import { Chip, Paper, Button, Box, Typography, Grid } from "@material-ui/core"
import TextField from '@material-ui/core/TextField';

const sizes = [
    {
        label: "IGTV",
        size: "1080x1920"
    },
    {
        label: "Facebook",
        size: "1920x1080"
    },
]

const VideoSizes = styled(({ 
    setDimensions,
    className
}) => {
    return (
        <div className={className}>
            {
                sizes.map(({ size, label }) => <Chip key={`animation-size-${label}-${size}`} clickable label={label} onClick={e => setDimensions(size)} />)
            }
        </div>
    )
})`
&& {
    display: flex;
    flex-wrap: wrap;

    & > * {
        margin: 4px;
    }
}
`

export default ({
    name,
    description,
    setDimensions
}) => {
    const [isRecording, setRecording] = useState(false);
    const [videoLength, setVideoLength] = useState(3);

    const exportVid = (blob) => {
        let url = URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.target = '_blank';
        document.body.appendChild(a);

        a.click();
    }

    const startRecording = () => {
        if (isRecording) return false;

        setRecording(true);

        const canvas = document.getElementsByTagName("canvas")[0];

        const chunks = [];
        const stream = canvas.captureStream();
        const rec = new MediaRecorder(stream);
        rec.ondataavailable = e => chunks.push(e.data);
        rec.onstop = e => exportVid(new Blob(chunks, { type: 'video/webm' }));

        rec.start();
        setTimeout(() => {
            setRecording(false);
            rec.stop()
        }, videoLength * 1000);
    }

    let buttonTitle = isRecording ? "Nimmt auf ..." : "Aufnahme starten"

    return (
        <Box m={2}>
            <Paper>
                <Box p={4}>
                    <Box marginBottom={4}>
                        <Typography gutterBottom variant="h4">{name}</Typography>
                        <Typography variant="body2" color="textSecondary" component="p" gutterBottom>{description}</Typography>
                    </Box>

                    <Box marginBottom={2}>
                        <Typography variant="subtitle1" gutterBottom>Video-Aufnahme</Typography>

                        <Grid container alignItems="center" spacing={2}>
                            <Grid item>
                                <TextField type="number" onChange={e => setVideoLength(e.target.value)} id="video-length" variant="filled" label="Video Länge (sek)" min={1} max={100} />
                            </Grid>
                            <Grid item>
                                <Button size="large" disabled={isRecording} onClick={startRecording} variant="contained" color="primary">{buttonTitle}</Button>
                            </Grid>
                        </Grid>
                    </Box>

                    <Typography variant="subtitle1" gutterBottom>Größe</Typography>
                    <VideoSizes setDimensions={setDimensions} />
                </Box>
            </Paper>
        </Box>
    )
}